interface TopPage {
  path: string;
  views: number;
}

interface Props {
  pages: TopPage[];
}

export default function TopPages({ pages }: Props) {
  const max = Math.max(...pages.map(p => p.views), 1);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">Top Pages</h3>
      {pages.length === 0 ? (
        <p className="text-sm text-gray-400 py-4 text-center">No data yet</p>
      ) : (
        <div className="space-y-3">
          {pages.map(p => (
            <div key={p.path}>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-700 font-mono truncate max-w-[75%]">{p.path}</span>
                <span className="text-gray-500 font-medium">{p.views}</span>
              </div>
              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-golf-orange rounded-full"
                  style={{ width: `${(p.views / max) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
